<template>
    <div v-if="$store.state.user.id_usuario == 1">
        <div class="badge badge-info">
            <a :href="link" target="_blank" class="text-white card-link">
                <i class="fab fa-wikipedia-w mr-2"></i>
                Mais Informações
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'topic'
    ],

    computed: { 
        link: function () {
            return 'http://wiki.klingo.com.br/wiki/' + this.topic;
        }
    }
}
</script>